<template>
  <div class="public-key-identification-authentication">
    <common-bg-plate>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-if="$utils.hasAuth($store, auth.certificate.publicKeyAuth.adminCert)"
          label="管理员证书"
          name="manager"
        >
          <manager-certs ref="manager"></manager-certs>
        </el-tab-pane>
        <el-tab-pane
          v-if="$utils.hasAuth($store, auth.certificate.publicKeyAuth.nodeUserCert)"
          label="节点-用户证书"
          name="node"
        >
          <node-user-certs ref="node"></node-user-certs>
        </el-tab-pane>
      </el-tabs>
    </common-bg-plate>
  </div>
</template>

<script>
import auth from '@/auth/index'
import managerCerts from './managerCerts'
import nodeUserCerts from './nodeUserCerts'
export default {
  name: 'PublicKeyIdentificationAuthentication',
  components: {
    managerCerts,
    nodeUserCerts
  },
  data() {
    return {
      activeName: 'manager',
      auth: auth
    }
  },
  mounted() {},
  methods: {
    handleClick(tab) {
      this.$refs[tab?.name]?.refresh()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.public-key-identification-authentication {
  
  .common-bg-plate {
    min-height: var(--base-main-router-body-avaliable-height);
  }
}
</style>
